<template>
    <div class="ti">
      <el-tabs v-model="activeName">
        <el-tab-pane label="预警设置" name="first">
          <div class="zhohang">
            <el-form label-width="100px">
                <el-form-item label="1级预警">
                  <el-input v-model="pay.warning1" placeholder="请输入预警时间"></el-input>
                  <span>单位（分钟），超过下单时间多少分钟</span>
                </el-form-item>
                <el-form-item label="2级预警">
                  <el-input v-model="pay.warning2" placeholder="请输入预警时间"></el-input>
                  <span>单位（分钟），超过下单时间多少分钟</span>
                </el-form-item>
                <el-form-item label="3级预警">
                  <el-input v-model="pay.warning3" placeholder="请输入预警时间"></el-input>
                  <span>单位（分钟），超过下单时间多少分钟</span>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="texts" @click="onSubmit">立即保存</el-button>
                </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
export default {
  name: 'RepairRwarning',
  data () {
    return {
     activeName: 'first',
     id:'',
     url:'',
     pay:{
         id:'',
         warning1:'',
         warning2:'',
         warning3:'',
     },
     fileList:[],
    }
  },
  //界面没出来前加载
  created() {
    
  },
  // 加载数据
  mounted(){
    this.url = this.$myhttp.defaults.baseURL + "/admin/payposts";
    this.id = this.$route.query.id;
    this.pay.appid = this.$route.query.appid;
    this.$myhttp.get('admin/rwarningget',{
    'Content-Type': 'application/json'
    }).then(backdata=>{ // 异步执行成功后
        this.pay = backdata.data[0];
    });
  },
  //事件
  methods: {
    //保存预警设置
    onSubmit(){
      console.log(this.pay);
      this.loading=true;
      this.$myhttp.post('admin/rwarningupdate',this.pay,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.loading=false;
            if(backdata.data == 200){
              this.$Message.success('保存成功!');
            }
      });
    }

  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path == "/Applets/appletsPay"){
        // var appid = this.$route.query.appid;
        // this.$myhttp.get('admin/getPay?type=zh&appid='+appid,{
        // 'Content-Type': 'application/json'
        // }).then(backdata=>{ // 异步执行成功后
        //     if(backdata.data['code'] == 209){
        //       this.pay={
        //         appid:appid,
        //         merchantNo:'',
        //         pwd:'',
        //         pfx:'',
        //         cer:'',
        //         type:"zh",
        //         state:1,
        //       };
        //     }else{
        //       this.pay = backdata.data[0][0];
        //     }
        // });
      }
    }
  },
}
</script>
<style scoped>
.ti{
    margin: 10px;
    width: 98%;
}
.zhohang{
  width: 50%;
}
.texts{
    color: rgb(240, 236, 236);
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/App/Repair/Rwarning.vue